import React, {useRef, useState} from 'react';
import {
  ActionSheet,
  Avatar,
  Button, Dialog,
  Form,
  ImageUploader, ImageUploadItem,
  ImageViewer,
  Input,
  NavBar,
  Selector,
  TextArea,
  Toast
} from "antd-mobile";
import {Await, useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";
import {paramsToFormData} from "../../../utils/paramsToFormData";
import {LoadingContext} from "../../../components/Loading/LoadingContext";
import ApiService from "../../../utils/ApiService";
import {getExtension, getObjectURL} from "../../../utils/StringHelper";

function WarnDetail(props:any) {
  const navigate = useNavigate()
  const [search,setSearch] = useSearchParams()
  const id = search.get('id')
  const { setIsLoading } = React.useContext(LoadingContext);
  const [_,upPage]=React.useState(Math.random());

  //头像处理
  const [avatarView, setAvatarView] = useState(false)
  const [avatarAction, setAvatarAction] = useState(false)
  const uploadRef = React.useRef<any>();


  //表单处理
  const tempObj = React.useRef<any>({});
  const formObj = React.useRef<any>({address_info:'loading...'});
  let formRef = React.useRef<any>();

  React.useEffect(()=>{
    getInfo();
  },[])

  const getInfo = async () => {
    setIsLoading(true);
    const ret = await ApiService.getWarnInfo(id);
    setIsLoading(false);
    if (ret && ret.code == 1) {
      let {id,handle_state,handle_text,handle_name} = ret.data;
      handle_name = handle_name || ret.data.login_name;
      formObj.current = {id,handle_state,handle_text,handle_name};

      tempObj.current = ret.data;
      setFileList(ret.data.handle_files);
      //不暂停1毫秒秒不好使
      setTimeout(()=>{
        formRef.current.resetFields();
      },1)
    } else if (ret) {
      Toast.show(ret.message)

    }
  }

  const saveInfo = async (values:any)=>{
    const data = {id,...values}
    setIsLoading(true);
    const ret = await ApiService.setWarnInfo(data);
    setIsLoading(false);
    if (ret && ret.code == 1) {
      Toast.show("操作成功");
    } else if (ret) {
      Toast.show(ret.message)
    }
  }


  const [fileList, setFileList] = useState<ImageUploadItem[]>([])

  const fileUpload = async (file: any) => {

    const data ={
      file,
      suffix: getExtension(file.name),
      father_id: id,
      father_type: 'warn',
      f_type: 'handle',
      createby: window.localStorage.getItem('userid')||'',
      overlap: '0',
      number: '0',
    };

    const ret = await ApiService.fileUpload(data);
    if (ret && ret.code == 1) {
      return {
        id:ret.data.id,
        f_type:ret.data.f_type,
        path:ret.data.path,
        url: getObjectURL(file),
      }
    } else if (ret) {
      Toast.show(ret.message)
    }

    return {
      url: require('../../../static/img/upload_err.png'),
    }
  }

  const deleteFiles=async (item: any) => {
    const result = await Dialog.confirm({
      content: '是否确认删除',
      onConfirm: () => {
      },
    })
    if(!result) return result;

    setIsLoading(true);
    const ret = await ApiService.deleteFile(item);
    setIsLoading(false);
    if (ret && ret.code == 1) {
      Toast.show("删除成功");
      return true;
    } else if (ret) {
      Toast.show(ret.message)
    }
    return false;
  }


  return (
    <div>
      <NavBar onBack={()=>navigate('/warn/list')}>{formObj.current.name}预警详情</NavBar>

      <Form ref={(val)=>{formRef.current=val}} layout='horizontal' mode='card' style={{'--prefix-width':'6em'}}
            onFinish={saveInfo}
            initialValues={formObj.current}
            footer={
              <Button block type='submit' color='primary' size='large'>
                保存处置信息
              </Button>
            }>
        <Form.Header>预警信息</Form.Header>
        <div style={{fontSize:'15px',lineHeight:'30px'}}>
          <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>预警标题</span>{tempObj.current.warn_title}
          <br/>
          <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>预警详情</span>{tempObj.current.warn_decription}
          <br/>
          <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>预警时间</span>{tempObj.current.create_time}
          <br/>
          <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>设备编码</span>{tempObj.current.device?.device_id}
          <br/>
          <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>设备类型</span>{tempObj.current.device?.device_type}
          <br/>
          <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>处置时间</span>{tempObj.current.handle_time||'待处置'}

          <br/>
        </div>
        <Form.Header>绑定人员信息</Form.Header>
        <div style={{fontSize:'15px',lineHeight:'30px'}}>
          {tempObj.current.people?.avatar?.url?
            <img src={tempObj.current.people?.avatar?.url} style={{ width: '80px',height: '80px',borderRadius:'10px',border:'1px dashed rgb(209 212 217)',float:'right' }}
                 onClick={()=>setAvatarView(true)}
            />
            :
            <img src={require('./img/upload.png')} style={{ width: '80px',height: '80px',borderRadius:'10px',border:'1px dashed rgb(209 212 217)',float:'right' }}/>
          }
          <ImageViewer
            image={tempObj.current.people?.avatar?.url}
            visible={avatarView}
            onClose={() => {
              setAvatarView(false)
            }}
          />
          <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>姓名</span>{tempObj.current.people?.name}
          <br/>
          <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>身份证号</span>{tempObj.current.people?.idcard}
          <br/>
          <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>地址</span>{tempObj.current.people?.address}
          <br/>
          <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>采集状态</span>{tempObj.current.people?.collect_time?'已采集':'未采集'}
          <br/>
        </div>
        <Form.Header>采集信息填写</Form.Header>
        <Form.Item label='处置状态' name="handle_state">
          <Selector
            options={[{label: '待处置',value: '待处置'},{label: '已处置',value: '已处置'}]}
          />
        </Form.Item>
        <Form.Item label='处置结果' name="handle_text">
          <TextArea placeholder='请输入'
                 maxLength={100}
                 rows={2}
                 showCount/>
        </Form.Item>
        <Form.Item label='处置人' name="handle_name">
          <Input placeholder='请输入' />
        </Form.Item>
        <Form.Item label='处置照片'>
          <ImageUploader
            value={fileList}
            onChange={setFileList}
            upload={fileUpload as any}
            onDelete={async (info) => {
              console.log('info',info)
              return deleteFiles(info);
            }}
            style={{'--cell-size':'60px'}}
          />
        </Form.Item>


      </Form>


    </div>
  );
}

export default WarnDetail;
